"use client";

import { useTranslations, useLocale } from "next-intl";
import {
  LogoMarquee,
  CUSTOMER_LOGOS_BY_LOCALE
} from "@/components/ui/LogoMarquee";

export function TrustedBySection() {
  const t = useTranslations("Home");
  const locale = useLocale();
  const logos =
    CUSTOMER_LOGOS_BY_LOCALE[locale] ?? CUSTOMER_LOGOS_BY_LOCALE["en"];

  return (
    <section className="py-12 px-6">
      <div className="mx-auto max-w-7xl text-center">
        <p className="text-xs text-text-muted uppercase tracking-widest font-body mb-8">
          {t("logoTrustLine")}
        </p>
        <LogoMarquee logos={logos} direction="left" pixelsPerSecond={30} />
      </div>
    </section>
  );
}
